(() => {
  function connect(root) {
    if (root.dataset.helpReady) return;
    root.dataset.helpReady = 'true';
    const select = root.querySelector('[data-help-topic-select]');
    const result = root.querySelector('[data-help-result]');
    if (result && !window.Shopify?.designMode) result.focus();
    if (!select) return;
    const guidance = root.querySelector('[data-help-guidance]');
    const group = root.querySelector('[data-help-order-group]');
    const order = root.querySelector('[data-help-order]');
    const label = root.querySelector('[data-help-order-label]');
    const missing = root.querySelector('[data-help-missing]');
    const missingLabel = root.querySelector('[data-help-missing-label]');
    const orderTopics = new Set(['tracking', 'return', 'change', 'problem', 'refund']);
    const hints = new Map([...root.querySelectorAll('[data-help-hint]')].map(node => [node.dataset.helpHint, node.content.textContent.trim()]));
    function update() {
      const needsOrder = orderTopics.has(select.value);
      group.hidden = select.value === 'sizing';
      missingLabel.hidden = !needsOrder;
      missing.disabled = !needsOrder;
      order.disabled = group.hidden || (needsOrder && missing.checked);
      order.required = needsOrder && !missing.checked;
      label.textContent = order.required ? label.dataset.required : label.dataset.optional;
      guidance.textContent = hints.get(select.value) || '';
      guidance.hidden = !guidance.textContent;
    }
    select.addEventListener('change', update);
    missing.addEventListener('change', update);
    root.addEventListener('click', event => {
      const link = event.target.closest('[data-help-topic]');
      if (!link || event.defaultPrevented || event.button !== 0 || event.metaKey || event.ctrlKey || event.shiftKey || event.altKey) return;
      if (!hints.has(link.dataset.helpTopic)) return;
      select.value = link.dataset.helpTopic;
      update();
    });
    update();
  }
  function init(scope = document) {
    if (scope.matches?.('[data-help-center]')) connect(scope);
    scope.querySelectorAll('[data-help-center]').forEach(connect);
  }
  init();
  document.addEventListener('shopify:section:load', event => init(event.target));
})();
